import { fetchData } from '../api/api';
import { handleError } from '../context/errors/errorUtils';

// sendLessonData используется при постоянной связи 
// fetchLessons только при первом обращении чтобы взять первый блок! 

// Утилита для создания FormData из данных
const createFormData = (data) => {
  const formData = new FormData();

  // Поля, ожидаемые сервером для /api/lessons
  const allowedFields = [
    'lessonId',
    'correctAnswer',
    'matchedOptionIndex',
    'step',
    'userId',
    'userText',
    'completeBlock',
    'userBlockId',
    'phraseCount',
    'score',
  ];

  // Добавляем аудио, если есть
  if (data.audioBuffer) {
    formData.append('audio', new Blob([data.audioBuffer], { type: 'audio/wav' }), 'audio.wav');
  }

  // Добавляем остальные поля
  Object.entries(data).forEach(([key, value]) => {
    if (allowedFields.includes(key) && value !== undefined) {
      formData.append(key, value);
    }
  });

  return formData;
};

export const sendLessonData = async (data = {}) => {
  try {
    const formData = createFormData(data);
    return await fetchData('/api/lessons', 'POST', formData);
  } catch (error) {
    handleError({
      code: 'LESSON_DATA_FETCH_ERROR',
      error,
      context: {
        module: 'sendLessonData',
        lessonId: data.lessonId,
        userId: data.userId,
        step: data.step,
      },
      showToUser: false, // Логируем на сервер, не показываем пользователю
    });
    throw error;
  }
};

export const fetchLessonTopics = async ({ userId }) => sendLessonData({ userId });

// fetchLessons только при первом обращении чтобы взять первый или нужный блок! 
export const fetchLessons = async ({ lessonId, blockId, userId, step = 0, completeBlock = false, setData, setLoading, setError }) => {
  try {
    const data = await sendLessonData({ lessonId, userId, step, completeBlock, userBlockId: blockId });
    const lesson = data?.lesson;

    if (!lesson) {
      throw new Error('Нет lesson в ответе сервера');
    }
    setData?.(lesson);
    return lesson;
  } catch (error) {
    handleError({
      code: 'FETCH_LESSON_FAILED',
      error,
      context: {
        module: 'fetchLessons',
        lessonId,
        blockId,
        userId,
        step
      },
      showToUser: true // тут имеет смысл показать ошибку пользователю
    });

    setError?.(error);
    throw error;
  } finally {
    setLoading?.(false);
  }
};


export const sendScoresToServer = async ({ lessonId, blockId, userId, completeBlock = true, score }) => {
  try {
    const data = await sendLessonData({ lessonId, userId, completeBlock, userBlockId: blockId, score });
	//console.log(`Получен ответ с сервера ${JSON.stringify(data)}`);
    return data?.success;
  } catch (error) {
    handleError({
      code: 'FETCH_RESULT_FAILED',
      error,
      context: {
        module: 'fetchLessons',
        lessonId,
        blockId,
        userId
      },
      showToUser: false // для отладки
    });
    throw error;
  } 
};




